// src/components/dialog/DlgDashboardCreate.tsx

import { CancelTwoTone, SaveTwoTone } from '@mui/icons-material'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material'
import { useEffect, useState } from 'react'

import { DashboardName, DashboardPool } from '@/types/domain/dashboard'
import { KARMA_ConfirmDialog } from '@/types/karma/dialog'

import { useDashboardPool } from '../../hooks'

type Props = KARMA_ConfirmDialog & {
  initialTitle?: DashboardName
}

export const DlgDashboardCreate = ({
  initialTitle = 'Neues Dashboard',
  open = true,
  onCancel,
  onConfirm,
  ...rest
}: Props) => {
  const dPool: DashboardPool = useDashboardPool()

  const [title, setTitle] = useState<DashboardName>('')

  // handle multiple instances of same title
  useEffect(() => {
    const instances = Number(
      dPool.filter(f => f.attributes.name.includes(initialTitle)).length
    )

    setTitle(instances > 0 ? `${initialTitle} (${instances})` : initialTitle)
  }, [dPool, initialTitle])

  const changeTitle = event => setTitle(event.target.value)

  const NO_TITLE = title === ''

  return (
    <Dialog fullWidth open={open} {...rest}>
      <DialogTitle>{initialTitle}</DialogTitle>

      <DialogContent>
        <TextField
          fullWidth
          label={'Titel'}
          onChange={changeTitle}
          sx={{ mx: 0, mb: 0, mt: 2 }}
          value={title}
        />
      </DialogContent>

      <DialogActions>
        <Button disabled={NO_TITLE} onClick={() => onConfirm(title)}>
          <SaveTwoTone />
          Erstellen
        </Button>

        <Button onClick={onCancel}>
          <CancelTwoTone />
          Abbrechen
        </Button>
      </DialogActions>
    </Dialog>
  )
}
